import { render, staticRenderFns } from "./UpdatePlayerProfile.vue?vue&type=template&id=91f39eb0&lang=html&"
import script from "./UpdatePlayerProfile.vue?vue&type=script&lang=js&"
export * from "./UpdatePlayerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports